import { dataAPI } from "../../api/axios";

export const SaveNewFeatureData = async (layer, attributes, shape, callback) => {
    let url = `Layers/${layer.Id}/Data`;

    let outPut = processData(layer, attributes, shape);
    dataAPI
        .post(url, outPut)
        .then(function (response) {
            try {
                callback({ status: response.status, layer: layer, data: response.data });
            } catch (error) {
                console.log(error);
            }
        })
        .catch(function (error) {
            errorHandler(error, layer, callback);
        });
};

export const UpdateFeatureData = async (
    featureID,
    layer,
    attributes,
    shape,
    callback
) => {
    let url = `Layers/${layer.Id}/Data/${featureID}`;

    let outPut = processData(layer, attributes, shape);
    dataAPI
        .put(url, outPut)
        .then(function (response) {
            try {
                callback({
                    status: response.status,
                    featureID: featureID,
                    layer: layer,
                    data: response.data,
                });
            } catch (error) {
                console.log(error);
            }
        })
        .catch(function (error) {
            errorHandler(error, layer, callback);
        });
};

export const DeleteFeatureData = async (featureID, layer, callback) => {
    let url = `Layers/${layer.Id}/Data/${featureID}`;

    dataAPI
        .delete(url)
        .then(function (response) {
            try {
                callback({
                    status: response.status,
                    featureID: featureID,
                    layer: layer,
                    data: response.data,
                });
            } catch (error) {
                console.log(error);
            }
        })
        .catch(function (error) {
            errorHandler(error, layer, callback);
        });
};

export const CreateRelatedRecordData = async (
    featureID,
    layer,
    relatedRecord,
    attributes,
    callback
) => {
    let url = `Layers/${layer.Id}/Data/${featureID}/RelatedRecords/${relatedRecord.RelatedTableID}/Data/`;

    let outPut = processRelatedRecordData(attributes);
    dataAPI
        .post(url, outPut)
        .then(function (response) {
            try {
                callback({
                    status: response.status,
                    featureID: featureID,
                    layer: layer,
                    relatedRecord: relatedRecord,
                    data: response.data,
                });
            } catch (error) {
                console.log(error);
            }
        })
        .catch(function (error) {
            errorHandler(error, layer, callback);
        });
};

export const UpdateRelatedRecordData = async (
    featureID,
    layer,
    relatedRecord,
    oid,
    attributes,
    callback
) => {
    let url = `Layers/${layer.Id}/Data/${featureID}/RelatedRecords/${relatedRecord.RelatedTableID}/Data/${oid}`;

    let outPut = processRelatedRecordData(attributes);
    dataAPI
        .put(url, outPut)
        .then(function (response) {
            try {
                callback({
                    status: response.status,
                    featureID: featureID,
                    layer: layer,
                    relatedRecord: relatedRecord,
                    recordID: oid,
                    data: response.data,
                });
            } catch (error) {
                console.log(error);
            }
        })
        .catch(function (error) {
            errorHandler(error, layer, callback);
        });
};

export const DeleteRelatedRecordData = async (
    featureID,
    layer,
    relatedRecord,
    oid,
    callback
) => {
    let url = `Layers/${layer.Id}/Data/${featureID}/RelatedRecords/${relatedRecord.RelatedTableID}/Data/${oid}`;

    dataAPI
        .delete(url)
        .then(function (response) {
            try {
                callback({
                    status: response.status,
                    featureID: featureID,
                    layer: layer,
                    relatedRecord: relatedRecord,
                    recordID: oid,
                    data: response.data,
                });
            } catch (error) {
                console.log(error);
            }
        })
        .catch(function (error) {
            errorHandler(error, layer, callback);
        });
};

const errorHandler = (error, layer, callback) => {
    if (
        error.response.status === 400 ||
        error.response.status === 401 ||
        error.response.status === 404
    ) {
        callback({
            status: error.response?.status,
            layer: layer,
            error:
                error.response?.data ??
                "An unknown error occurred while processing the request. Please retry again in a few minutes. If the error continues, please contact your site administrator. ",
        });
    } else {
        callback({
            status: error.response?.status ?? 500,
            layer: layer,
            error:
                error.response?.data ??
                "An unknown server-side error occurred while processing the request. Please retry again in a few minutes. If the error continues, please contact your site administrator. ",
        });
    }
};
const processRelatedRecordData = (attributes) => {
    let output = {};
    attributes.forEach((element) => {
        output[element.fieldName] = element.fieldValue ?? "";
    });
    return output;
};
const processData = (layer, attributes, shape) => {
    let outPut = {
        wkid: layer.LayerWKID,
        feature: {
            properties: {},
        },
    };
    switch (layer.GeometryType.toLowerCase()) {
        case "point":
            outPut.feature.geometry = {
                type: "Point",
                coordinates: [shape[0].X, shape[0].Y, shape[0].Z],
            };
            break;
        case "polyline":
        case "line":
            let l = shape.map((v) => {
                return [v.X, v.Y, v.Z];
            });
            outPut.feature.geometry = { type: "Line", coordinates: l };
            break;
        case "polygon":
            let p = shape.map((v) => {
                return [v.X, v.Y, v.Z];
            });
            outPut.feature.geometry = { type: "Polygon", coordinates: [p] };
            break;
        default:
            break;
    }
    attributes.forEach((element) => {
        outPut.feature.properties[element.fieldName] = element.fieldValue ?? "";
    });
    return outPut;
};

export const encodeDefaultValue = (defaultValue, userGivenName, addressIn, shape) => {
    if (!defaultValue) {
        return "";
    }
    let outValue = "";
    let defaultValueLower = defaultValue.toString().toLowerCase();
    let parts = defaultValueLower.split("@");

    switch (parts[0]) {
        case "{accuracyxy}":
            //TODO
            break;
        case "{accuracyz}":
            //TODO
            break;
        case "{currentuser}":
            return userGivenName;
        case "{datetimenow}":
            return new Date().getTime();
        case "{datetimeutcnow}":
            return new Date().getTime();
        case "{geocodedaddress}":
            return addressIn;
        case "{locx}":
            return shape[0].X ?? 0;
        case "{locy}":
            return shape[0].Y ?? 0;
        case "{locz}":
            return shape[0].Z ?? 0;
        case "{shapearea}":
            //TODO
            break;
        case "{shapelength}":
            //TODO
            break;
        default:
            outValue = defaultValue.toString();
            break;
    }
    return outValue;
};
export const encodeDefaultValueRelatedRecord = (
    defaultValue,
    userGivenName,
    featureData
) => {
    if (!defaultValue) {
        return "";
    }
    let outValue = "";
    let defaultValueLower = defaultValue.toString().toLowerCase();
    let parts = defaultValueLower.split(".");

    switch (parts[0]) {
        case "{currentuser}":
            return userGivenName;
        case "{datetimenow}":
            return new Date().getTime();
        case "{datetimeutcnow}":
            return new Date().getTime();
        case "{feature":
            let propName = defaultValue.substring(
                defaultValue.lastIndexOf(".") + 1,
                defaultValue.lastIndexOf("}")
            );
            return featureData.values_[propName] ?? "";
        default:
            outValue = defaultValue.toString();
            break;
    }
    return outValue;
};
